// ============================================
// NAVIGATION JAVASCRIPT
// Active states, smooth interactions
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  
  // Get current page path
  const currentPath = window.location.pathname;
  
  // Highlight active nav link
  const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
  navLinks.forEach(link => {
    const linkPath = new URL(link.href).pathname;
    
    // Exact match
    if (linkPath === currentPath) {
      link.classList.add('active');
    }
    
    // Parent section match (for dropdown items)
    if (currentPath.startsWith(linkPath) && linkPath !== '/') {
      link.classList.add('active');
    }
  });
  
  // Close mobile menu on link click
  const navbarCollapse = document.getElementById('mainNav');
  if (navbarCollapse) {
    const navLinks = navbarCollapse.querySelectorAll('.nav-link:not(.dropdown-toggle)');
    
    navLinks.forEach(link => {
      link.addEventListener('click', function() {
        // Check if mobile menu is open
        if (navbarCollapse.classList.contains('show')) {
          const bsCollapse = new bootstrap.Collapse(navbarCollapse, {
            toggle: true
          });
        }
      });
    });
  }
  
  // Smooth dropdown animations
  const dropdownMenus = document.querySelectorAll('.dropdown-menu');
  dropdownMenus.forEach(menu => {
    menu.addEventListener('show.bs.dropdown', function() {
      this.style.display = 'block';
      setTimeout(() => {
        this.classList.add('show');
      }, 10);
    });
  });
  
  // Smart Header: Hide utility bar on scroll, keep navbar sticky
  let lastScroll = 0;
  const navbar = document.querySelector('.navbar');
  const headerWrapper = document.querySelector('.header-wrapper');
  const utilityBar = document.querySelector('.utility-bar');
  const body = document.body;
  
  // Get utility bar height for smooth transitions
  const utilityBarHeight = utilityBar ? utilityBar.offsetHeight : 0;
  
  if (navbar && headerWrapper) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      // Add scrolled class for shadow effect
      if (currentScroll > 50) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
      
      // Smart header: hide utility bar when scrolling down past threshold
      if (currentScroll > 100) {
        // Scrolled past threshold - hide utility bar
        body.classList.add('utility-bar-hidden');
        headerWrapper.classList.add('utility-hidden');
      } else {
        // At top of page - show utility bar
        body.classList.remove('utility-bar-hidden');
        headerWrapper.classList.remove('utility-hidden');
      }
      
      lastScroll = currentScroll;
    });
  }
  
});

// Optional: Enhanced shadow on scroll
document.addEventListener('DOMContentLoaded', function() {
  const style = document.createElement('style');
  style.textContent = `
    .navbar.scrolled {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    }
  `;
  document.head.appendChild(style);
});

